import { ComumHttpService } from '../../comum-http.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Area } from './../../modelos/area';

@Component({
  selector: 'app-form-area',
  templateUrl: './form-area.component.html',
  styleUrls: ['./form-area.component.css']
})
export class FormAreaComponent implements OnInit {

  @Input() area: Area;
  @Input() modo: string;

  @Output() areaEvent: EventEmitter<string>;

  constructor(private _comumHttpService: ComumHttpService) {
    this.areaEvent = new EventEmitter<string>();
  }

  ngOnInit() {
  }

  emit(): void {
    this.areaEvent.emit('formul&aacute;rio completo');
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/components/form-area/form-area.component.ts